export const ServicesData = {
	labServices: {
		title: "Lab Services",
		subheader: "Select lab test(s)",
		error: "Please select at least one lab test",
		calendly: "https://calendly.com/okb-hope-health/lab-tests",
		options: {
			Hematology: [
				["Full Blood Count", 50],
				["ESR", 50],
				["Hemoglobin (Hb)", 30],
				["Sickling Test", 40],
				["Thyroid Function Test", 180],
				["Blood Grouping", 30],
			],
			Microbiology: [
				["H-Pylori", 30],
				["Typhi Dot (Widal Test)", 30],
				["Stool RE", 30],
				["Gonorrhoea", 50],
				["Chlamydia", 50],
				["Urine Culture", 100],
				["Urine RE", 30],
			],
			"Immunology and Serology": [
				["Hepatitis B", 20],
				["Hepatitis B Profile", 80],
				["Hepatitis C", 20],
				["VDRL - Syphilis", 30],
				["Retro Screen [HIV]", 50],
				["RDT for Malaria", 25],
				["Serum Pregnancy Test", 40],
				["Urine Pregnancy Test", 30],
			],
			Biochemistry: [
				["HbA1c", 100],
				["Fasting Blood Sugar", 10],
				["Beta HCG", 130],
				["Blood Film for Malaria", 30],
				["Glycated Hemoglobin", 120],
				["Liver Function Test", 140],
				["Renal Function Test", 120],
				["Lipid Profile", 120],
				["INR", 100],
				["Uric Acid", 80],
				["Hb Electrophoresis", 80],
				["D-Dimer", 200],
				["Leutinizing Hormone", 80],
				["Progesterone", 80],
				["Prolactin", 80],
				["Prostate Specific Antigen", 130],
			],
		},
	},
	mobileVan: {
		title: "Mobile Van",
		subheader: "Select service(s)",
		error: "Please select one service",
		calendly: "https://calendly.com/okb-hope-health/mobile-van",
		options: {
			Hematology: [
				["Hemoglobin (Hb)", 30],
				["ESR", 50],
				["Sickling Test", 40],
				["Blood Grouping", 30],
			],
			"Immunology and Serology": [
				["Hepatitis B", 20],
				["Hepatitis B Profile", 80],
				["Hepatitis C", 20],
				["VDRL - Syphilis", 30],
				["Retro Screen [HIV]", 50],
				["RDT for Malaria", 25],
				["Urine Pregnancy Test", 30],
			],
			Microbiology: [
				["H-Pylori", 30],
				["Typhi Dot (Widal Test)", 30],
				["Stool RE", 30],
				["Urine RE", 30],
			],
			Biochemistry: [
				["HbA1c", 100],
				["Hb Electrophoresis", 80],
				["Fasting Blood Sugar", 10],
				["Blood Film for Malaria", 30],
			],
		},
	},
	telehealth: {
		title: "Telehealth",
		subheader: "Select service(s)",
		error: "Please select at least one service",
		calendly: "https://calendly.com/okb-hope-health/telehealth",
		options: {
			Services: [
				["General consultation", 20],
				["Mental Health Consultation", 50],
				["Eye Service Consultation", 45],
				["Weight Loss and Nutrition Consultation", 50],
			],
		},
	},
};
